var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticStyle:{"display":"inline-block"},attrs:{"as":"span"}},[_c('img',_vm._b({ref:"resizableImg",class:[_vm.isResizing ? 'resize-handle' : _vm.isDraggable && 'drag-handle'],attrs:{"draggable":_vm.isDraggable,"data-drag-handle":_vm.isDraggable}},'img',_vm.node.attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }